import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from "./router";
import { backend_url } from "./config/url.config.ts";


Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        accessToken: null,
        loggingIn: false,
        loginError: null
    },
    mutations: {
        loginStart: state => (state.loggingIn = true),
        loginStop: (state, errorMessage) => {
            state.loggingIn = false;
            state.loginError = errorMessage;
        },
        updateAccessToken: (state, accessToken) => {
            state.accessToken = accessToken;
        },
        logout: state => {
            state.accessToken = null;
        }
    },
    actions: {
        doLogin({ commit }, loginData) {
            commit("loginStart");
            
            // Inicia la cadena de promesas devolviendo el resultado del primer POST
            return axios
                .post(backend_url + "/users/login/", {
                    ...loginData
                })
                .then(response => {
                    // Primer POST exitoso: Guarda token, detiene carga e informa
                    localStorage.setItem("accessToken", response.data.token);
                    commit("loginStop", null);
                    commit("updateAccessToken", response.data.token);

                    // Devuelve la promesa del segundo POST para encadenarla
                    return axios
                        .post(
                            backend_url + "/users/info", {
                                type: "monitor",
                                email: loginData.email
                            }, {
                                headers: {
                                    "x-access-token": response.data.token
                                }
                            }
                        );
                })
                .then(response => {
                    // Segundo POST exitoso: Guarda info de usuario
                    //console.log(response);
                    localStorage.setItem("name", response.data.name + " " + response.data.last_name);
                    localStorage.setItem("first_name", response.data.name);
                    localStorage.setItem("last_name", response.data.last_name);
                    localStorage.setItem("is_admin", response.data.is_admin);
                    localStorage.setItem("profile_image", backend_url + "/" + response.data.profile_image);
                    localStorage.setItem("email", response.data.email);
                    localStorage.setItem("user_uuid", response.data.user_id);
                    localStorage.setItem("project_id", response.data.project_id || 0);

                    // Devuelve la promesa del tercer POST para encadenarla
                    return axios.post(backend_url + "/api/binnacles/monitor/save/", {
                        "module": "Login",
                        "action": "Inicio de sesión",
                        "observation": `${localStorage.getItem("name")}`,
                        "email": localStorage.getItem("email")
                    }, {
                        headers: {
                            "x-access-token": localStorage.getItem("accessToken")
                        }
                    });
                })
                .then(() => {
                    // Tercer POST (binnacle) exitoso: Redirecciona
                    if (!!router.history.current.query.next) {
                        router.push(router.history.current.query.next);
                    } else {
                        router.push("/mapa");
                    }
                })
                .catch(error => {
                    // CUALQUIER error en la cadena de promesas (status code 4xx o 5xx) será capturado aquí.
                    // Esto incluye errores de /users/login, /users/info o /api/binnacles/monitor/save.
                    
                    // Asume que el error de login tiene 'message' y otros errores pueden tener 'error' en su payload.
                    const errorMessage = error.response.data.message || error.response.data.error || "Error desconocido";

                    commit("loginStop", errorMessage);
                    commit("updateAccessToken", null);
                    
                    // Rechaza la promesa del action para que el componente que la llama sepa que falló.
                    return Promise.reject(errorMessage);
                });
        },
        fetchAccessToken({ commit }) {
            commit("updateAccessToken", localStorage.getItem("accessToken"));
        },
        logout({ commit }) {
            axios.post(backend_url + "/api/binnacles/monitor/save/", {
                    "module": "Login",
                    "action": "Cierre de sesión",
                    "observation": `${localStorage.getItem("name")}`,
                    "email": localStorage.getItem("email")
                }, {
                    headers: {
                        "x-access-token": localStorage.getItem("accessToken")
                    }
                })
                .then(() => {
                    localStorage.removeItem("accessToken");
                    localStorage.removeItem("name");
                    localStorage.removeItem("is_admin");
                    commit("logout");
                    router.push("/login");
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    }
});

export default store;
